import { Tokens } from '@tmov/design-system/theme/types';
import styled from 'styled-components';

export const Container = styled.div``;

export const Divider = styled.div`
  height: 0;
  border-top: 1px solid ${Tokens.eixods.colors.neutral.grey[10]};
`;

export const Section = styled.div`
  width: 100%;
  padding: 48px 0;
  gap: 32px;

  display: flex;
`;

export const SectionLabel = styled.div`
  width: 222px;
`;

export const SectionInputs = styled.div`
  gap: 32px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const SectionInputsRow = styled.div`
  gap: 24px;

  display: flex;
  flex-direction: row;
`;
